import styled from "styled-components";

export const ContainerTechs = styled.main``;
